'use strict'

/**
 * @classname UpdateFormActionAttribute
 * @classdesc クリックで対象のフォームのaction属性を更新する
 */
export default class UpdateFormActionAttribute {
	/**
	 * @constructor
	 * @param {jQuery} $e - $('.update-form-action-attribute')
	 */
	constructor($e, controller) {
		console.log('UpdateFormActionAttribute.constructor')
		this._$e = $e
		this._controller = controller
		this._action = this._$e.data('action')
		this._$form = $(this._$e.data('update-action-attribute-form'))
		this._$e.on('click', () => this.onClick())
	}


	/**
	 * クリックのコールバック
	 *
	 * @memberof UpdateFormActionAttribute
	 * @return {undefined}
	 */
	onClick() {
		console.log(`UpdateFormActionAttribute.onClick`)
		console.log(`action: ${this._action} / form selector: ${this._$e.data('update-action-attribute-form')}`)
		if (this._$e.data('action')) this._$form.attr('action', this._$e.data('action'))
	}
}
